/** Vendor-neutral channel names for the tracking event bus. Each subscriber (GA4, Relewise, ...) maps
 * these onto its own vocabulary — adding a vendor means adding a subscriber, never touching a trigger site. */
export const TrackingTopic = {
  CartItemAdded: 'cart_item_added',
  CartItemRemoved: 'cart_item_removed',
  CartUpdated: 'cart_updated',
  ProductCategoryViewed: 'product_category_viewed',
  ItemListViewed: 'item_list_viewed',
  ItemViewed: 'item_viewed',
  ItemSelected: 'item_selected',
  UserLoggedIn: 'user_logged_in',
  OrderPlaced: 'order_placed',
  PageViewed: 'page_viewed',
  SearchPerformed: 'search_performed',
  TrackingErrorOccurred: 'tracking_error_occurred',
} as const

export type TrackingTopic = (typeof TrackingTopic)[keyof typeof TrackingTopic]
